/* eslint-disable no-unused-vars */
import { campaignReportsDefaultSelectedCols } from 'constants';

export const downloadCSV = (data, events, type, filename) => {
  const csvContent = convertToCSV(data, events, type);

  const utf8BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([utf8BOM, csvContent], { type: 'text/csv;charset=UTF-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

function convertToCSV(objArray, events, type) {
  if (!objArray) return;
  let array = typeof objArray !== 'object' ? JSON.parse(objArray) : structuredClone(objArray);
  const firstCols = type === 'Apps' ? [type, 'pba_number', 'cm_app_cpi'] : [type];
  const allCols = campaignReportsDefaultSelectedCols.cols.map((col) => col.colName);

  let csv = '';

  const columns = [...new Set([...firstCols, ...allCols, 'attributed_installs'])];

  const selectedEvents = events.filter((event) => event.isSelected);

  const eventTitles = selectedEvents.map((event) => event.eventName);
  const eventTitlesCohort = eventTitles.map((title) => title + ' (Cohort)');

  // add event props
  let eventIds = [];
  let eventIdsCohort = [];
  selectedEvents.forEach((event) => {
    eventIds.push('events_' + event.eventId);
    eventIdsCohort.push('eventsCohort_' + event.eventId);
  });

  const fullCols = [...columns, ...eventIds, ...eventIdsCohort];

  const formatedHeaders = columns
    .map((header) => {
      let newHeader = header;
      switch (header) {
        case 'pba_number':
          newHeader = 'App ID';
          break;
        case 'cm_app_cpi':
          newHeader = 'Bid';
          break;
        case 'Impressions':
          newHeader = 'Viewable Impressions';
          break;
        case 'video_views':
          newHeader = 'Video Views';
          break;
        case 'video_completed':
          newHeader = 'Video Ended';
          break;
        case 'attributed_installs':
          newHeader = 'Attributed Installs';
          break;
        default:
          newHeader = header;
      }

      return newHeader;
    })
    .concat(eventTitles, eventTitlesCohort);

  csv += formatedHeaders.join(',') + '\n';

  const formatedArray = array.map((item) => {
    // truncate numbers
    for (const key in item) {
      const num = typeof item[key] === 'number' ? item[key] : parseFloat(item[key]);
      if (!Number.isNaN(num) && item[key] !== '' && item[key] !== null) {
        item[key] = num.toFixed(3);
      } else if (!item[key]) {
        item[key] = '0';
      }
    }

    const formatedItem = {};

    // format velues - select props and add symbols
    fullCols.forEach((column) => {
      const numWithCommas = (+item[column]).toLocaleString();
      if (column === 'eCPM') {
        // The stored eCPM field arrives pre-rounded to 2 decimals, so compute it
        // from Cost/Impressions for full precision — mirrors getECPM() in
        // RightSideHeader.jsx so the CSV matches the value shown in the UI.
        const impressions = +item['Impressions'];
        const cost = +item['Cost'];
        const ecpm =
          impressions > 100 && Number.isFinite(cost / impressions)
            ? (cost / impressions) * 1000
            : +item[column] || 0;
        const ecpmStr = ecpm.toLocaleString(undefined, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        });
        // Leading tab forces Excel to keep the cell as text so it doesn't
        // re-round the currency value down to 2 decimals on display.
        formatedItem[column] = '\t$' + ecpmStr;
      } else if (column === 'Cost') {
        formatedItem[column] = '$' + numWithCommas;
      } else if (column === 'CTR' || column === 'CR') {
        formatedItem[column] = numWithCommas + '%';
      } else {
        formatedItem[column] = numWithCommas;
      }

      if ((type === 'Creative' && column === 'Creative') || Number.isNaN(+item[column])) {
        formatedItem[column] = item[column].replaceAll(/<br\s*\/?\s*>/g, ' ');
      }
    });

    return formatedItem;
  });

  // add data rows
  for (const row of formatedArray) {
    const values = fullCols.map((header) => {
      const escaped = String(row[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csv += values.join(',') + '\n';
  }

  return csv;
}
